<div #overlay class="overlay">
    <div class="content center-content">
        <div class="column-flex">
            <mat-icon svgIcon="lock" class="icon" />
            <div class="title">
                {{ 'access-removed.dialog.form.title' | translate: { vessel: data.vessel } }}
            </div>
            <div class="subtitle">
                {{ 'access-removed.dialog.form.subtitle' | translate }}
            </div>

            <div class="buttons-container">
                <div class="cancel button" (click)="cancel()">
                    {{ 'access-removed.dialog.form.button' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
